import { computed } from 'vue';

import { reduce } from '@exchange/helpers/lodash-fp-no-cap';
import { authService } from '@exchange/libs/auth/service/src';
import { settingsService } from '@exchange/libs/settings/service/src';
import { launchdarkly, type PartnerPromoNotificationFlag } from '@exchange/libs/utils/launchdarkly/src';

export interface UIPartner {
  key: string;
  name: string;
  description: string;
  logo: string;
  offer: string | undefined;
  offerParams: Dictionary<string> | undefined;
  createdAt?: number /** used to check how new the partner is to show green dot */;
  endsAt?: number;
}

class PartnersService {
  public newPartners = computed(() => launchdarkly.flags['partner-promo-notifications'].value);

  public showPartnersDot = computed(
    () =>
      authService.hasBeenAuthenticated &&
      (reduce((acc: boolean, partner: PartnerPromoNotificationFlag, partnerKey: string) => acc || this.hasGreenDot(partnerKey, partner), false, this.newPartners.value) as boolean),
  );

  public isInTimeframe = (createdAt: number, endsAt?: number) => {
    const now = new Date().getTime();
    const isPromoOlderThanUser = (authService.idTokenData.firstLogin || 0) < createdAt;
    const hasPromoEnded = endsAt && endsAt < now;

    return isPromoOlderThanUser && !hasPromoEnded;
  };

  public wasPartnerSeen = (partnerKey: string) => Boolean(settingsService.settings.userSettings.seenPartnersAt[partnerKey]);

  public hasGreenDot = (partnerKey: string, partner: PartnerPromoNotificationFlag) => this.isInTimeframe(partner.startsAt, partner.endsAt) && !this.wasPartnerSeen(partnerKey);
}

const partnersService = new PartnersService();

export default partnersService;
